export var convertWidthToPercentage = function convertWidthToPercentage(val) {
  return val ? "".concat(100 * (val / 12), "%") : undefined;
};
export var formatMargin = function formatMargin(val) {
  return "calc(-0.5 * ".concat(val, ")");
};
export var formatPadding = function formatPadding(val) {
  return "calc(0.5 * ".concat(val, ")");
};
export function getValueAtBreakpoint(val, breakpoint, fallback) {
  if (!val) {
    return fallback;
  }
  if (breakpoint === 'xs') {
    var _val$xs;
    return (_val$xs = val.xs) !== null && _val$xs !== void 0 ? _val$xs : fallback;
  }
  if (breakpoint === 'sm') {
    var _ref, _val$sm;
    return (_ref = (_val$sm = val.sm) !== null && _val$sm !== void 0 ? _val$sm : val.xs) !== null && _ref !== void 0 ? _ref : fallback;
  }
  if (breakpoint === 'md') {
    var _ref2, _ref3, _val$md;
    return (_ref2 = (_ref3 = (_val$md = val.md) !== null && _val$md !== void 0 ? _val$md : val.sm) !== null && _ref3 !== void 0 ? _ref3 : val.xs) !== null && _ref2 !== void 0 ? _ref2 : fallback;
  }
  if (breakpoint === 'lg') {
    var _ref4, _ref5, _ref6, _val$lg;
    return (_ref4 = (_ref5 = (_ref6 = (_val$lg = val.lg) !== null && _val$lg !== void 0 ? _val$lg : val.md) !== null && _ref6 !== void 0 ? _ref6 : val.sm) !== null && _ref5 !== void 0 ? _ref5 : val.xs) !== null && _ref4 !== void 0 ? _ref4 : fallback;
  }
  if (breakpoint === 'xl') {
    var _ref7, _ref8, _ref9, _ref10, _val$xl;
    return (_ref7 = (_ref8 = (_ref9 = (_ref10 = (_val$xl = val.xl) !== null && _val$xl !== void 0 ? _val$xl : val.lg) !== null && _ref10 !== void 0 ? _ref10 : val.md) !== null && _ref9 !== void 0 ? _ref9 : val.sm) !== null && _ref8 !== void 0 ? _ref8 : val.xs) !== null && _ref7 !== void 0 ? _ref7 : fallback;
  }
}